import React from "react";
import FaqQuestion from "./faqquestion";
export default function PortfolioFaq() {
  return (
    <div className="portfoliofaq">
      <h2 className="h2headerportfolio">FAQs</h2>
      <p>
        NeuroGen empowers medical professionals with innovative tools to
        practice, refine, and excel in their skills. <br />
        From differential diagnosis to case simulations and research
        verification,
      </p>

      <div className="portfoliofaqbody">
        <FaqQuestion
          question="Is NeuroGen safe to use?"
          answer="NeuroGEN is built with rigorous safety standards to ensure secure and reliable use in every interactions. It is designed to continuously learn and improve , becoming more accurate and effective the more it is used . This adaptive learning process allows NeuroGEN to deliver increasingly personalised and optimised outcomes , ensuring a higher standard of care and performance with each engagement ."
        />
        <FaqQuestion
          question="How does NeuroGen help with diagnostics?"
          answer="NeuroGen offers advanced tools that aid in differential diagnosis, case simulations, and research verification, enhancing diagnostic accuracy and efficiency."
        />
        <FaqQuestion
          question="Can I customize NeuroGen for my needs?"
          answer="Yes, NeuroGen provides customizable features to tailor the platform according to your specific medical practice requirements."
        />
      </div>
    </div>
  );
}
